export default __webpack_public_path__ + "static/media/1.e1e4eff3.png";